import React, { Component } from 'react';
import { graphql, createRefetchContainer, QueryRenderer } from 'react-relay';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import fantasyLeaderboardSubscription from '../../data/subscription/fantasyLeaderboardSubscription';
import LeaderboardTable from './LeaderboardTable.js';
import { useStyles } from './styles.js';

class LeaderboardResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      data: [],
    };
  }

  componentDidMount() {
    if (this.props.fetch_option) {
      this.setState({
        records: this.props[this.props.fetch_option][this.props.fetch_option]
          .data.guests,
        data: this.props[this.props.fetch_option][this.props.fetch_option].data,
      });
    }

    if (this.props.event_id) {
      fantasyLeaderboardSubscription(
        { event_id: this.props.event_id },
        response => {
          this._refetch();
        },
        error => console.log('error'),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps[this.props.fetch_option][this.props.fetch_option].code == 200 &&
      nextProps[this.props.fetch_option][this.props.fetch_option].data
    ) {
      this.setState({
        records:
          nextProps[this.props.fetch_option][this.props.fetch_option].data
            .guests,
        data: nextProps[this.props.fetch_option][this.props.fetch_option].data,
      });
    }
  }

  _refetch = () => {
    this.props.relay.refetch(
      this.props.filter,
      null, // We can use the refetchVariables as renderVariables
      () => {
        this.setState({ loading: false });
      },
      { force: true },
    );
  };

  render() {
    return (
      <LeaderboardTable records={this.state.records} data={this.state.data} event_id={this.props.event_id} />
    );
  }
}

LeaderboardResult.propTypes = {
  className: PropTypes.string,
};

export default createRefetchContainer(
  withStyles(useStyles)(LeaderboardResult),
  {
    getWMSmallBusinessLeaderboard: graphql`
      fragment LeaderboardResult_getWMSmallBusinessLeaderboard on Query
        @argumentDefinitions(
          filter: {
            type: "fantasyFilterType"
            defaultValue: {
              leaderboard_access: "String"
              guest_name: null
              option_name: null
            }
          }
        ) {
        getWMSmallBusinessLeaderboard(filter: $filter) {
          code
          message
          data {
            number_of_guests
            guests {
              _id
              guest_name
              fantasy_points
              score
            }
          }
        }
      }
    `,
  },
  graphql`
    query LeaderboardResultResultRefetchQuery($filter: fantasyFilterType) {
      ...LeaderboardResult_getWMSmallBusinessLeaderboard
        @arguments(filter: $filter)
    }
  `,
);
